import * as SliderPrimitive from '@radix-ui/react-slider';
import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '@/lib/cn';

export function Slider({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof SliderPrimitive.Root>) {
  return (
    <SliderPrimitive.Root
      className={cn('relative flex w-full touch-none select-none items-center', className)}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1 w-full grow bg-border">
        <SliderPrimitive.Range className="absolute h-full bg-accent" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className="block h-3 w-3 bg-text border border-border-strong focus-visible:outline focus-visible:outline-1 focus-visible:outline-accent"
        aria-label="Volume"
      />
    </SliderPrimitive.Root>
  );
}
